import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/usuario.service";

const initialState = {
    usuarios: [],
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
    currentPage: 1,
    totalRows: 0
};

export const getUsuarios = createAsyncThunk(
    "usuarios/getUsuarios",
    async (data, thunkAPI) => {
        try {
            return await service.getAllUsuarios(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createUsuario = createAsyncThunk(
    "usuario/create",
    async (usuarioData, thunkAPI) => {
        try {
            return await service.createUsuario(usuarioData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateUsuario = createAsyncThunk(
    "usuario/update",
    async (usuarioData, thunkAPI) => {
        try {
            return await service.updateUsuario(usuarioData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deleteUsuario = createAsyncThunk(
    "usuario/delete",
    async (id, thunkAPI) => {
        try {
            return await service.deleteUsuario(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


// Reset password
export const resetPassword = createAsyncThunk(
    "usuario/reset_password",
    async (data, thunkAPI) => {
        try {
            return await service.resetPassword(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const usuarioSlice = createSlice({
    name: "usuario",
    initialState,
    reducers: {
       reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsuarios.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getUsuarios.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.usuarios = action.payload.data; // Asignar los datos de usuarios
                state.currentPage = action.payload.pagination.currentPage; // Asignar la página actual
                state.totalRows = action.payload.pagination.totalRows; // Asignar el total de filas
            })
            .addCase(getUsuarios.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Mensaje de error
            })
            .addCase(createUsuario.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createUsuario.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.usuarios.push(action.payload); // Agregar el nuevo usuario a la lista
            })
            .addCase(createUsuario.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Mensaje de error
            })
            .addCase(updateUsuario.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateUsuario.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                const index = state.usuarios.findIndex(usuario => usuario.id === action.payload.id);
                if (index !== -1) {
                    state.usuarios[index] = action.payload; // Actualizar el usuario en la lista
                }
            })
            .addCase(updateUsuario.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; //
                // Mensaje de error
            }
            )
            .addCase(deleteUsuario.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteUsuario.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.usuarios = state.usuarios.filter(usuario => usuario.id !== action.payload.id); // Eliminar el usuario de la lista
            })
            .addCase(deleteUsuario.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Mensaje de error
            })
            .addCase(resetPassword.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.message = action.payload; // Mensaje de éxito
                const index = state.usuarios.findIndex(usuario => usuario.id === action.payload.id);
                if (index !== -1) {
                    state.usuarios[index] = action.payload; // Actualizar el usuario en la lista
                }
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Mensaje de error
            });
            
    }
});
export const { reset } = usuarioSlice.actions;
export default usuarioSlice.reducer;